{
  "Mon": "Maandag",
  "Tue": "Dinsdag",
  "Wed": "Woensdag",
  "Thu": "Donderdag",
  "Fri": "Vrijdag",
  "Sat": "Zaterdag",
  "Sun": "Zondag",
  "CORE": {
    "notificationDateFormat": "dd-MM-yy",
    "update": "Loading...",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} Uw ski's wachten op u",
    "help": "Help",
    "notification": {
      "ok": "OK"
    },
    "skiHire": "Skiverhuur"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Betaal in de munt van uw eigen land (EUR of CHF). Alpy.com neemt voor u de wisselkoerskosten over.",
        "searchHeadline": "Op welke plaats wilt u graag ski´s of een snowboard huren?"
      },
      "showTownReserveEarlyEnoughInfo": "Let er a.u.b. op dat skiverhuurders tijdens het seizoen niet altijd alle materialen nog beschikbaar hebben. Wij adviseren daarom altijd vooraf te reserveren."
    },
    "offer": {
      "title": "Waarom boeken met {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Gegarandeerd de beste prijzen voor ski huur bij een online boeking",
      "listedBrands": "Gebruikte merken",
      "topTowns": "Top skiverhuurplaatsen"
    },
    "sidebar": {
      "hotlineItalic": "Wij helpen u graag!!",
      "callNow": "Bel nu op: ",
      "hotline": "Hotline"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Vul alstublieft de leeftijd van elk kind (de leeftijd aan het begin van de huurperiode) in",
        "onePersonRequired": "Kies op zijn minst één persoon",
        "enterTown": "Kies uw skigebied"
      },
      "minified": {
        "users": "{{ number_adults }} Volwassen, {{ number_children }} Kinderen",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE dd-MM-yy"
      },
      "datePickerDisplayFormat": "EEEEEE dd-MM-yy",
      "datePickerPreviousMessage": "U kunt uw huuruitrusting ophalen in de winkel op <span>{{ date }}</span> na 15:30. Nachtskiën uitgesloten.",
      "datePickerPreviousMessageDateFormat": "dd-MM-yy",
      "formSearchLabel": "Plaats, Skigebied, Land, Winkelnaam, …",
      "formSearchInfo": "Een ogenblik a.u.b.; de door u gewenste plaats wordt gezocht...",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "{{ count }} winkel(s)",
      "formSearchResultShowAll": "Toon alle {{ count }} resultaten",
      "formSearchResultGroupLocations": "Skiplaats",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Regio´s",
      "formSearchResultGroupCountries": "Landen",
      "formSearchButtonLabelDelivery": "Vanaf {{price}}",
      "deliverToHotel": "Ik wil dat de uitrusting gratis naar mijn accommodatie wordt geleverd!",
      "formStartDate": "Eerste huurdag",
      "formEndDate": "Laatste huurdag",
      "formNumberOfPeople": "Personen",
      "formAdultsLabel": "Volwassen",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "Volwassenen",
        "adultSingle": "Volwassene",
        "adultMultiple": "Volwassenen",
        "childNone": "Kinderen",
        "childSingle": "Kind",
        "childMultiple": "Kinderen"
      },
      "formAdultsLabelInfo": "ouder dan 18 jaar aan het begin van de huurperiode",
      "formChildrenLabel": "Kinderen",
      "formChildrenLabelInfo": "onder de 18 jaar aan het begin van de huurperiode",
      "formChildInputLabelInfo": "Hou oud zal uw kind / Hoe oud zullen uw kinderen aan het begin van de huurperiode zijn?",
      "formChildInputPlaceholder": "hoe oud?",
      "formPromotionCode": "Promotiecode",
      "formPromotionCodeNotFound": "Deze promotiecode bestaat niet.",
      "formSearchButtonLabel": "Zoeken",
      "promocode": {
        "couponCodeIsInCart": "De couponcode {{ code }} is toegevoegd aan uw winkelwagen en zal worden opgenomen op de betaalpagina.",
        "typePromo": "PROMO",
        "typeCoupon": "COUPON"
      },
      "noResults": "Geen resultaten gevonden"
    },
    "shopSort": {
      "sortPriceDistanceTooltip": "Sorteer op \"Prijs & afstand\" sorteert de goedkoopste winkels naar boven (die direct in de geselecteerde stad zijn) en de duurdere naar beneden. Onder de \"direct in de stad gelegen\" winkels vindt u nog meer winkels die gerangschikt zijn op afstand buiten de door u geselecteerde stad. Een uitzondering vormen de winkels met het label \"TOP SHOP\" en \"BESTE PRIJS\" (tegen betaling), die altijd hoger gerangschikt zijn."
    },
    "navigation": {
      "skihire": "Skiverhuur",
      "skischool": "Skischolen",
      "accommodation": "Accomodaties",
      "aboutUs": "Over ons",
      "helpCenter": "Help Center",
      "subnavBooking": "Boeking",
      "subnavAdditionalOffers": "Extra Aanbiedingen",
      "subnavGroupBooking": "Groepsboekingen",
      "subnavTermsAndConditions": "Algemene voorwaarden",
      "subnavBecomePartner": "Word partner",
      "subnavPrivacyPolicy": "Bepalingen gegevensbeveiliging",
      "subnavHelp": "Contact",
      "myAlpinresorts": "Mijn Alpy.com",
      "subnavLogin": "Login",
      "subnavLogout": "Logout",
      "subnavBookingsAndCancellations": "Boekingen & Annuleringen",
      "subnavPersonalSettings": "Persoonlijke instellingen",
      "career": "Carrière",
      "blog": "Blog"
    },
    "geoIp": {
      "chooseACountry": "Kies a.u.b. een land"
    }
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "Over Alpy.com",
      "metaDescription": "Hier vindt u alle info over het tgeam van Alpy.com. Stel vertrouwen in een van de grootste skiverhuur- en skischolen-netwerken van Europa!"
    },
    "imprint": {
      "title": "Impressum {{ productName }}",
      "metaDescription": "Impressum von {{ productName }}"
    },
    "privacy": {
      "title": "Gegevensbescherming | {{ productName }}",
      "metaDescription": "Bepalingen gegevensbescherming van A{{ productName }}"
    },
    "termsAndConditions": {
      "title": "Algemene voorwaarden | {{ productName }}",
      "metaDescription": "Algemene voorwaarden van {{ productName }}"
    },
    "additionalOffers": {
      "title": "Extra Aanbiedingen",
      "metaDescription": ""
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "boeking-annuleren",
    "SKIHIREENTRY": "skiverhuur",
    "COUNTRIES": "landen",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "zoeken"
    },
    "SKISCHOOLENTRY": "skischool",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "impressum",
      "PRIVACYPOLICY": "bepalingen-gegevensbescherming",
      "TERMSANDCONDITIONS": "algemene-voorwaarde",
      "HELP": "hulp",
      "ABOUTUS": "over-ons",
      "ADDITIONALOFFERS": "extra-aanbiedingen",
      "HOWTO": "handleiding"
    }
  }
}
